import GetRequestingPhysiciansModal from './GetRequestingPhysiciansModal';

export default GetRequestingPhysiciansModal;
